<template>
  <div class="product-card" @click="goToProduct">
    <div class="product-image">
      <img v-if="product.image" :src="getImgUrl(product.image)" />
      <v-icon v-else></v-icon>

      <div v-if="product.discount > 0" class="discount-badge">
        -{{ product.discount }}%
      </div>

      <v-btn icon class="quick-add-btn" @click.stop="addToCart" aria-label="Add to cart">
        <!-- color="white" -->
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </div>

    <div class="product-info text-center">
      <h3 class="product-name">{{ product.name }}</h3>

      <div class="product-price">
        <span class="current-price">
          {{ websiteSettings.COIN_CODE }}{{ discountedPrice.toFixed(2) }} 
        </span>

        <span v-if="product.discount > 0" class="original-price">
          {{ Number(product.price).toFixed(2) }} 
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: "ProductCard",
  props: {
    product: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ...mapState({
      websiteSettings: state => state.websiteSettings
    }),
    discountedPrice() {
      const price = parseFloat(this.product.price || 0);
      const discount = this.product.discount || 0;
      return price * (1 - discount / 100);
    },
  },

  methods: {
    goToProduct() {
      this.$router.push(`/e-commerce-web/product/${this.product.id}`);
    },

    addToCart() {
      this.$store.dispatch("cart/addToCart", {
        product: this.product,
        quantity: 1,
      });
    },

    getImgUrl(item) {
      let domain = `${this.$store.state.serverDomain}/storage/`;
      return domain + item;
    },
  },
};
</script>

<style scoped>
/* ============================= */
/* Glass Product Card */
/* ============================= */

.product-card {
  position: relative;
  border-radius: 18px;
  overflow: hidden;
  cursor: pointer;

  /* Glass effect */
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);

  border: 1px solid rgba(255, 255, 255, 0.25);

  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
  transition: all 0.35s ease;
}

/* subtle light overlay */
.product-card::before {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: 18px;
  background: linear-gradient(120deg,
      rgba(255, 255, 255, 0.35),
      rgba(255, 255, 255, 0.05));
  pointer-events: none;
}

.product-card:hover {
  transform: translateY(-8px) scale(1.02);
  box-shadow: 0 18px 45px rgba(0, 0, 0, 0.25);
}

/* ============================= */
/* Product Image */
/* ============================= */

.product-image {
  position: relative;
  height: 200px;
  overflow: hidden;
}

@media (max-width: 600px) {
  .product-image {
    height: 130px;
  }
}

.product-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.6s ease;
}

.product-card:hover .product-image img {
  transform: scale(1.08);
}

/* ============================= */
/* Discount Badge */
/* ============================= */

.discount-badge {
  position: absolute;
  top: 12px;
  left: 12px;
  background: rgba(255, 71, 87, 0.9);
  color: white;
  padding: 6px 12px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 13px;
  backdrop-filter: blur(8px);
}

/* ============================= */
/* Quick Add Button */
/* ============================= */

.quick-add-btn {
  position: absolute;
  top: 12px;
  right: 12px;

  background: rgba(255, 255, 255, 0.3) !important;
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);

  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.35);

  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
}

.quick-add-btn:hover {
  background: rgba(255, 255, 255, 0.45) !important;
  transform: scale(1.1);
}

/* ============================= */
/* Product Info */
/* ============================= */

.product-info {
  padding: 18px;
  background: rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(12px);
}

.product-name {
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 10px 0;
  /* color: white; */
}

.product-price {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
}

.current-price {
  font-size: 18px;
  font-weight: 700;
  color: #2ed573;
}

.original-price {
  font-size: 14px;
  color: #777;
  text-decoration: line-through;
}
</style>